import { Filters } from "components/filters/filters.component";
import { Page } from "components/page/page.component";
import { View } from "components/view/view.component";
import style from './roomOccupationMonthReport.module.css';
import { Button } from "components/button/button.component";
import { Icon } from "components/icon/icon.component";
// import { Alert } from "components/alert/alert.component";
import { useEffect, useState, useMemo } from "react";
import { getOneMonthBefore } from "utils/date.util";
import { useGetRoomOccupationMonthlyReportFileUrlApi, useGetRoomOccupationMonthsReportApi } from "api/reports.api";
import { Skeleton } from "components/skeleton";
import { FilterType } from "model/filter.model";

type RoomOccupationMonthReportPageProps = {
    companyId?: string
}

export function RoomOccupationMonthReportPage({ companyId }: RoomOccupationMonthReportPageProps) {

    const {data: months, get: getMonths, loading: loadingMonths} = useGetRoomOccupationMonthsReportApi()
    const {get: getFileUrl, loading: loadingFileUrl} = useGetRoomOccupationMonthlyReportFileUrlApi()
    const [filters, setFilters] = useState<FilterType>()

    useEffect(() => {
        if (!companyId) return
        getMonths()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyId])

    async function downloadExcelReport() {
        if (!months || months.length <= 0) return
        if (!filters?.date) return
        const month = filters.date.getMonth() + 1
        const year = filters.date.getFullYear()
        const fileUrl = await getFileUrl( `${year}-${month.toString().padStart(2, '0')}-01`)
        if (!fileUrl) return
        window.open(fileUrl, '_blank');
    }

    const isFilterMonthAvailable = useMemo(() => {
        if (!months || months.length <= 0) return false
        if (!filters?.date) return false
        const fYear = filters.date.getFullYear()
        const fMonth = (filters.date.getMonth() + 1).toString().padStart(2, '0')
        const target = `${fYear}-${fMonth}-01`
        return months.some(m => {
            try {
                const dt = new Date(m)
                const key = `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, '0')}-01`
                return key === target
            } catch (e) {
                return false
            }
        })
    }, [months, filters])

    return <Page menu header title="Relatório Mensal de Ocupação de Salas">
        <View className={style.Content}>
            
            <View className={style.ContentHeader}>
                {loadingMonths ? <Skeleton /> :
                <Filters 
                    companyId={companyId}
                    showDate
                    enabledDates={months ? months.map(m => new Date(m)) : []}
                    initialDate={getOneMonthBefore(new Date())}
                    dateType="month"
                    dateErrorMessage="Ainda não há dados para o mês selecionado"
                    onChange={setFilters}
                />}
            </View>
            <View className={style.ExportSection}>
                <View className={style.ExportSectionButtons}>
                    <Button 
                        variant='contained' 
                        startIcon={<Icon className={style.Icons}>border_all</Icon>}
                        loading={loadingMonths || loadingFileUrl}
                        onClick={downloadExcelReport}
                        disabled={loadingMonths || loadingFileUrl || !isFilterMonthAvailable}
                    >
                        Exportar para Excel
                    </Button>
                </View>
                {/* {errorMessage && <Alert severity="error" onClose={() => {setErrorMessage(undefined) }} style={{marginTop: '50px'}}>
                    {errorMessage}
                </Alert>} */}
            </View>
        </View>
    </Page>
}